<template>
  <div :class="['avatar', aCls]" :style="style">
    <svg-icon v-if="['group', 'department'].includes(type)" cls="avatar-icon" :icon="`avatar-${type}`"/>
    <img v-else-if="picUrl" :src="picUrl" />
    <template v-else-if="letter">{{letter.toUpperCase()}}</template>
    <svg-icon v-else :icon="type === 'tourists' ? 'user-tourists' : 'user-unknow'" />
  </div>
</template>
<script>
import config from '../../config'

const avatarColor = ['#ffe17b', '#ff7398', '#ff8278', '#72dca2', '#8aa6f9']
const typeColor = {
  'group': '#6ca2ff',
  'department': '#6ca2ff',
  'empty': '#a5a9aa',
  'own': '#f4f6f7',
  'external': '#aec2ff'
}
export default {
  name: 'Avatar',
  props: {
    user: Object,
    type: String,
    icon: String,
    isExternal: Boolean,
    isActive: Boolean | String,
    color: String,
    size: {
      type: Number,
      default: 40
    }
  },
  data () {
    return {
      avatarColor,
      typeColor
    }
  },
  computed: {
    bgColor () {
      return typeColor[this.type] || 'inherit'
    },
    picUrl () {
      if (this.user && this.user.profile_pic_key) {
        const { id, profile_pic_key } = this.user
        return this.type === 'enterprise' ? config.imageUrl + `/enterprise/pic_download?enterprise_id=${id}&profile_pic_key=${profile_pic_key}`
          : config.imageUrl + `/apps/users/pic_download?user_id=${id}&profile_pic_key=${profile_pic_key}`
      }

      return ''
    },
    letter () {
      const nameFirstLetter = this.user && (this.user.name_first_letter || (this.user.full_name_pinyin && this.user.full_name_pinyin[0]))
      let userActive = this.isActive || (this.isActive === undefined && true)
      return userActive && this.user && ((this.user.name && this.user.name.charAt(0)) || nameFirstLetter)
    },
    aCls () {
      if (['group', 'department'].includes(this.type)) {
        return 'dept'
      } else if (this.picUrl) {
        return 'img'
      } else if (this.letter) {
        return 'letter'
      } else {
        return ''
      }
    },
    style () {
      const baseStyle = {
        color: this.color || '#fff',
        backgroundColor: this.bgColor || '#bcbcbc',
        userSelect: 'none',
        display: 'inline-block',
        textAlign: 'center',
        verticalAlign: 'middle',
        lineHeight: this.size + 'px',
        fontSize: this.size / 2 + 'px',
        borderRadius: '50%',
        height: this.size + 'px',
        width: this.size + 'px',
        overflow: 'hidden'
      }

      if (!['group', 'department'].includes(this.type) && !this.picUrl && this.letter) {
        return Object.assign({}, baseStyle, {
          backgroundColor: this.isExternal ? typeColor.external : avatarColor[this.user.id % 5]
        })
      } else {
        return baseStyle
      }
    }
  },
  beforeDestroy () {
    this.isDestoryed = true
    if (this.img && document.body.contains(this.img)) {
      document.body.removeChild(this.img)
    }
  }
}
</script>
<style lang="postcss">
.avatar {
  & svg,
  & img {
    width: 100%;
    height: 100%;
  }
}
</style>
